import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/tmp/8de59257c360032/components/consent/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/tmp/8de59257c360032/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/tmp/8de59257c360032/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/tmp/8de59257c360032/components/layout/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/tmp/8de59257c360032/components/layout/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadImages"] */ "/tmp/8de59257c360032/components/ui/PreloadImages.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8de59257c360032/styles/globals.css");
